module.exports = Jsw.skinUrl + "/images/clear-search.png?c022c431eedbe669278180412386b137";